import Repository from './Repository';

const resource = "/whitelist";
export default {
    verify(data) {
        return Repository.post(`${resource}/check/`, data);
    }
}